import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { datadogRum } from "@datadog/browser-rum";
import { useCompareBar } from "@cinch-labs/shared-compare-cars";
import { Actions as SearchActions, Context as SearchContext } from "@cinch-nx/data-search";
import { CompareIcon } from "./compare-icon";
import cx from "classnames";
import sharedStyles from "../../compare-and-favourite-bar/compare-and-favourite-bar.module.css";
import { Context } from "../../../datadog-data";
export var CompareCTA = function(param) {
    var vehicle = param.vehicle;
    var ref = useCompareBar(), removeVehicle = ref.removeVehicle, addVehicle = ref.addVehicle, comparisonVehicles = ref.comparisonVehicles, setShowModal = ref.setShowModal, maxNumberOfItems = ref.maxNumberOfItems;
    var vehicleId = vehicle.vehicleId, make = vehicle.make, model = vehicle.model, thumbnailUrl = vehicle.thumbnailUrl;
    var isSavedToCompare = comparisonVehicles.some(function(compareVehicle) {
        return vehicleId === compareVehicle.vehicleId;
    });
    var numberOfComparedVehicles = comparisonVehicles.length;
    var handleCompareOnClick = function() {
        var vehicleData = {
            vehicleId: vehicleId,
            vehicleTitle: "".concat(make, " ").concat(model),
            vehicleImage: thumbnailUrl,
            vehicleMake: make,
            vehicleModel: "".concat(model)
        };
        if (numberOfComparedVehicles >= maxNumberOfItems && !isSavedToCompare) {
            datadogRum.addAction(SearchActions.COMPARE_SHOWING_MODAL, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                maxNumberOfVehicles: maxNumberOfItems
            });
            return setShowModal(true);
        }
        if (isSavedToCompare) {
            datadogRum.addAction(SearchActions.COMPARE_VEHICLES_CTA_VEHICLE_REMOVED, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                vehicle: {
                    vehicleId: vehicleId,
                    make: make,
                    model: model
                }
            });
            removeVehicle(vehicleId);
        } else {
            datadogRum.addAction(SearchActions.COMPARE_VEHICLES_CTA_VEHICLE_ADDED, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                vehicle: {
                    vehicleId: vehicleId,
                    make: make,
                    model: model
                }
            });
            addVehicle(vehicleData);
        }
    };
    return /*#__PURE__*/ _jsxs("button", {
        className: cx(sharedStyles.ctaButton, isSavedToCompare && sharedStyles.toggled),
        onClick: handleCompareOnClick,
        children: [
            /*#__PURE__*/ _jsx(CompareIcon, {
                isToggled: isSavedToCompare
            }),
            " Compare"
        ]
    });
};
